import { Card, CardBody, Col, Row } from 'reactstrap';
// import { LearningListData } from '../../../../data/miscellaneous/Learning';
import { dynamicImage } from '../../../../utils';
import { Image } from '../../../../coreComponents/Image';
import { CourseData } from '../../../../types/Tables';
import { CourseLessonDetailsData, StudentCourseLesson } from '../../../../types/Courses';
import { useEffect, useState } from 'react';
import { baseLang, secondsToHhMmSs } from '../../../../lib/utils';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
type BlogBoxListProps = {
  courseLessonsData?: CourseLessonDetailsData;
};
const BlogBoxList = ({ courseLessonsData }: BlogBoxListProps) => {
  const { t, i18n } = useTranslation();
  const pageLang = baseLang(i18n.language);
  const location = useLocation();
  const isMyCoursePath = location.pathname.includes('my-courses');
  const urlPrefix = isMyCoursePath
    ? '/courses/my-courses/lesson'
    : '/courses/student-courses/lesson';
  const [lessons, setLessons] = useState<StudentCourseLesson[]>([]);

  useEffect(() => {
    if (courseLessonsData?.categories) {
      const flatLessons = courseLessonsData.categories.flatMap((el) => el.lessons);
      setLessons(flatLessons);
    }
  }, [courseLessonsData?.categories]);

  const getTranslate = (
    element: 'title' | 'description',
    lang: string,
    component: StudentCourseLesson,
  ) => {
    if (lang === 'en') {
      return component[element];
    } else {
      const translation = component.translations.find((el) => el.lang === lang);
      if (!translation) {
        return component[element];
      }
      return translation[element];
    }
  };
  return (
    <>
      {!courseLessonsData ? (
        <Col xl="12">
          <Card>
            <div className="text-center p-5">
              <h5>{t('courses.noCoursesTitle')}</h5>
              <p>{t('courses.noCoursesMsg')}</p>
            </div>
          </Card>
        </Col>
      ) : (
        lessons.map((data) => (
          <Col xl="12" key={data.id}>
            <Card>
              <Link
                to={`${urlPrefix}/${data.id}`}
                state={{
                  from: location.pathname,
                  scrollY: window.scrollY, // remember scroll
                }}
              >
                <CardBody>
                  <Row className="blog-box blog-list">
                    {}
                    <Col sm="5">
                      <Image
                        className="img-fluid sm-100-w"
                        src={`${process.env.REACT_APP_BACKEND_STATIC}/coursesPics/${data.lessonCover}`}
                        alt=""
                      />
                    </Col>
                    <Col sm="7">
                      <div className="blog-details">
                        <div className="blog-date">
                          {/* <span>{data.date}</span> {data.month} */}
                        </div>
                        <h3>{getTranslate('title', pageLang, data)}</h3>
                        <div>
                          <ul className="blog-social simple-list flex-row">
                            {data.video && (
                              <li>
                                {' '}
                                <i className="icofont icofont-clock-time"></i>{' '}
                                {secondsToHhMmSs(data.video[0]?.length)}
                              </li>
                            )}
                            {/* <li>
                              {!data.studentScores?.length ? (
                                <>
                                  <i className="icofont icofont-book"></i>{' '}
                                 {t('courses.courseStudyStatus.inProgress')}
                                </>
                              ) : data.studentScores?.[0]?.status === 'completed' ? (
                                <>
                                  <i className="icofont icofont-award"></i>{' '}
                                  {t('courses.courseStudyStatus.completed')}
                                </>
                              ) : (
                                <>
                                  <i className="icofont icofont-book"></i>{' '}
                                  {t('courses.courseStudyStatus.inProgress')}
                                </>
                              )}
                            </li> */}
                            {/* <li>
                              {data.studentScores?.[0]?.status === 'completed' && (
                                <>
                                  <i className="icofont icofont-score-board"></i>
                                  {data.studentScores[0].score}{' '} / 100
                                </>
                              )}
                            </li> */}
                          </ul>
                          <hr />
                          <p className="mt-0">{getTranslate('description', pageLang, data)}</p>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </CardBody>
              </Link>
            </Card>
          </Col>
        ))
      )}
    </>
  );
};
export default BlogBoxList;
